import './styles.scss';
import React, { useState, useMemo } from 'react';
import dynamic from 'next/dynamic';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { Select } from 'components/partials/Fields/FormikSelect';

const MapHere = dynamic(() => import('components/MapHere'), { ssr: false });

export const TopNav = ({
    setTab,
    active_tab,
    getAuctionLocations,
    sortOptions = [],
    onSortByChange,
    sort_column_index,
    disabled = false,
}) => {
    const [showMap, setShowMap] = useState(false);

    const locations = useMemo(() => getAuctionLocations(active_tab === 'active' ? 'auctions' : 'upcoming_auctions'), [active_tab, getAuctionLocations]);

    return (
        <>
            <Row>
                <Col md={12} className="auction-search-map">
                    {(showMap && locations.length > 0) && <MapHere height="342px" width="100%" locations={locations} />}
                </Col>
            </Row>
            <Row className="d-flex justify-content-between">
                <Col xs={12} sm={5} className="mt-2">
                    <div
                        className="btn btn-blue w-100"
                        onClick={() => setShowMap(!showMap)}
                    >
                        Show Map
                    </div>
                </Col>
                <Col xs={12} sm={5} className="top-nav-sort mt-2">
                    <Select
                        variant="info"
                        size="lg"
                        onChange={onSortByChange}
                        value={sort_column_index}
                    >
                        {sortOptions.map((option, index) => (
                            <option
                                value={index}
                                id={`sort_option_${index}`}
                                key={`sort_option_${index}`}
                            >
                                {option.label}
                            </option>
                        ))}
                    </Select>
                </Col>
            </Row>
            <div className={`row-md ${disabled ? 'disabled' : ''}`}>
                <Tabs
                    activeKey={active_tab}
                    onSelect={k => setTab(k)}
                >
                    <Tab eventKey="active" title="ACTIVE" tabClassName="top-nav__tab w-50" />
                    <Tab eventKey="upcoming" title="UPCOMING" tabClassName="top-nav__tab w-50" />
                </Tabs>
            </div>
        </>
    );
};